import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

function Navbar({ pageTitle }) {
	return (
		<Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e2e8f0', py: 1.5 }}>
			<Container maxWidth="md">
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					<Link to="/tools" style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#6d28d9', textDecoration: 'none', flexShrink: 0 }}>
						<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
							<line x1="19" y1="12" x2="5" y2="12"/>
							<polyline points="12 19 5 12 12 5"/>
						</svg>
						<Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#6d28d9' }}>Dashboard</Typography>
					</Link>
					<Box sx={{ width: '1px', height: '16px', bgcolor: '#e2e8f0', flexShrink: 0 }} />
					{/* The page's one semantic <h1> — most tool pages have no other heading,
					    so this is what search engines and screen readers read as the topic. */}
					<Typography component="h1" sx={{ fontSize: '15px', fontWeight: 700, color: '#0f172a', margin: 0 }}>
						{pageTitle}
					</Typography>
				</Box>
			</Container>
		</Box>
	);
}

export default Navbar;
